<template>
  <div id="app">

    <!-- <app-sideNav v-if="name != 'pageNotFound' && path != '/login' && userRoleSlug != 'super-admin' &&  name != 'resetPassword' && name!='switchClient'"></app-sideNav> -->
    <app-sideNav v-if="sideNavAccess()"></app-sideNav>
    <div :class="{'wrapper':sideNavAccess(),'o-superadmin-wrapper':userRoleSlug == 'super-admin' }" id="page">
      <app-header v-if="headerNavAccess()"></app-header>
      <!-- <app-header v-if="name != 'pageNotFound' && path != '/login' &&  name != 'resetPassword' && name!='switchClient'"></app-header> -->
      <router-view></router-view>
      <vue-progress-bar></vue-progress-bar>
   </div>
  </div>
</template>

<script>
    import HeaderNav from './components/headerNav';
    import SideNav from './components/sideNav';
    import store from './store/store';
    import {publicRoutes} from './routes.js';
    import dateTimeConvert from './timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                userRoleSlug: 'userRoleSlug',
                userRole: 'userRole',
                getBrowserSettingsLanguage: 'getBrowserSettingsLanguage',
                userLanguage: 'userLanguage',
                getTokenExpiry: 'getTokenExpiry'
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
                
                  return("desktop" != check ? !0 : !1);
            },
        },

        name: 'App',
        components: {
            'app-header': HeaderNav,
            'app-sideNav': SideNav,
        },
        watch: {
            '$route' (to, from) {
                this.path = to.path;
                this.name = to.name;
            },
        },
        data() {
            return {
                path: this.$route.path,
                name: this.$route.name,
                loginHide: true,
                pageTitle: 'Call Steward',
                metaDescription: 'We create and maintain a set of online tools that allow dispatchers and stagehands to communicate quickly and efficiently about the availability of work.',
                metaKeywords: ['IATSE', 'Stagehand', 'Dispatch', 'Grip', 'Teamsters'],
                canonicalUrl: 'https://www.callsteward.com/',
                organizationData: {
                    name: 'CallSteward',
                    url: 'https://www.callsteward.com/',
                    description: 'We create and maintain a set of online tools that allow dispatchers and stagehands to communicate quickly and efficiently about the availability of work.',
                    sameAs: [
                        'https://www.facebook.com/callsteward',
                        'https://x.com/callsteward'
                    ]
                }
            }
        },
        beforeMount() {},
        mounted() {
            this.setMetaTags();
            this.setStructuredData();

            if ($('.wrapper').find('.resetPassword').length) {
                $('.wrapper').css('margin-left', '0px');
            }
            if ($('.wrapper').find('.pageNotFound').length) {
                // $('.wrapper').css('margin-left', '0px');
            }
        },
        async created() {
            console.log(".COM Server - Desk - Root Component - Pipeline Check - : 2025/03/26 16:15 IST");
            let current_date_time = moment.utc().format('YYYY-MM-DD HH:mm:ss');
            // let expiry_date = moment(this.getTokenExpiry).format('YYYY-MM-DD HH:mm:ss');
            // console.log("current time: " + current_date_time+",", "expiry time: " + expiry_date);
            if ((this.getTokenExpiry!='')&&(!(moment(current_date_time).isBefore(this.getTokenExpiry)))) {
                // console.log(this.getTokenExpiry);
                this.$cookies.remove("csLogin", "/mobile");
                this.$cookies.remove("csLogin");
                this.$cookies.remove("date_format");
                this.$cookies.remove("time_format");
                this.$cookies.remove("time_zone");
                localStorage.removeItem('vuex');
                localStorage.clear();
                this.$store.dispatch('setTokenExpiry', '');
                this.$notify.error({
                    message: 'Your Authorization has expired.Please login again',
                    title: 'Authorization has expired'
                });
                await this.$router.push({
                    name: 'LoginPage', 
                    path: '/login'
                })
            }
            if(this.userLanguage && this.userLanguage != '') 
                localStorage.setItem("lang", this.userLanguage); 
            else {
                let lang = localStorage.getItem("lang")
                if(lang && lang != '' && (typeof lang == 'string')) 
                    localStorage.setItem("lang", lang); 
                else localStorage.setItem("lang", 'en');        
            }
            this.$store.dispatch('saveBrowserSettingsLanguage', localStorage.getItem("lang"));
           

            const isMobile = this.deviceDetector;

            if(isMobile && window.location.hostname !='localhost'){
            // if(isMobile){


                // viewport.setAttribute('content', 'width=1024');
                if((this.isLoggedIn()) && (!this.userRole || this.userRole == 'employee')) {

                    // window.location.href = window.location.href.split('#')[0]+"#/mobile/";
                }else if(!this.isLoggedIn()) {
                    let secondPath = window.location.href.split('#')[1];
                    if((secondPath != '/login') || secondPath != '/' || secondPath != '' ) {
                    // console.log(this.isLoggedIn());

                    }else {

                        // window.location.href = window.location.href.split('#')[0]+"#/mobile/login";
                    }
                }
            }else{
                this.loginHide = true;

            }
        },
        methods: {
            sideNavAccess(){
                if(publicRoutes.indexOf(this.name) ==-1 && this.name!='switchClient' && this.userRoleSlug != 'super-admin'){
                    return true;
                }
                return false;
            },
            headerNavAccess(){
                if(publicRoutes.indexOf(this.name) ==-1 && this.name!='switchClient'){
                    return true;
                }
                return false;
            },
            isLoggedIn(){
                var user = dateTimeConvert.getCookie('csLogin');

                if(user === "")
                    return false;
                else
                    return true;
            },
            setMetaTags() {
                document.title = this.pageTitle;
                document.querySelector('meta[name="description"]').setAttribute('content', this.metaDescription);
                document.querySelector('meta[name="keywords"]').setAttribute('content', this.metaKeywords.join(', '));
                document.querySelector('link[rel="canonical"]').setAttribute('href', this.canonicalUrl);
                // console.log("query selector 123",document.querySelector);
            },
            setStructuredData() {
                const script = document.createElement('script');
                script.type = 'application/ld+json';
                script.text = JSON.stringify(this.organizationData);
                document.head.appendChild(script);
            }
        },
        store

    }

</script>
<style>
    .err-msg {
        color: red
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        /*color: #2c3e50;*/
        /*margin-top: 0px;*/
        /*height: 100%;*/
        position: relative;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue